import {OverlayButton} from '@/components/player-v2/OverlayButton';
import {TimelineElementContainer} from '@/components/player-v2/TimelineElement/TimelineElementContainer';

type BasicCtaTimelineElementProps = {
  icon?: React.ReactElement;
  iconPosition?: 'left' | 'right';
  onClick: () => void;
  text: string;
};

/**
 * Timeline element component that renders a cta in the bottom right-hand corner.
 */
export const BasicCtaTimelineElement: React.FC<
  BasicCtaTimelineElementProps
> = ({icon, iconPosition, onClick, text}) => {
  return (
    <TimelineElementContainer position="bottomRight">
      <OverlayButton
        icon={icon}
        iconPosition={iconPosition}
        onClick={onClick}
        text={text}
      />
    </TimelineElementContainer>
  );
};
